import React from 'react';
import "../../Assets/Css/Upcoming.css"; 
import poster1 from '../../Assets/Images/poster1.svg'
import poster2 from '../../Assets/Images/poster2.svg'
import poster3 from '../../Assets/Images/poster3.svg'



const images = [poster1, poster2,poster3];

const Upcoming = () => {
  return (
    <div className="image-grid-wrapper">
      <div className="image-grid-container">
        <h2 className="upcoming-projects">Upcoming Projects</h2>
        <div className="image-grid">
          {images.map((img, index) => (
            <div key={index} className="image-item">
              <img src={img} alt={`Project ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Upcoming;